import React from 'react'
import Layout from './../../Layout';
import PayedRequestContainer from '../../../../Components/PayRequest/PayedRequestContainer/PayedRequestContainer';

const PayedRequestList = () => {
  return (
    <Layout>
        <PayedRequestContainer/>
    </Layout>
  )
}

export default PayedRequestList